// extracted by mini-css-extract-plugin
export var barContainer = "_5y-0";
export var extraThin = "_5y-3";
export var fillBar = "_5y-6";
export var fillContainer = "_5y-4";
export var overflow = "_5y-8";
export var overflowContainer = "_5y-5";
export var regular = "_5y-7";
export var thick = "_5y-1";
export var thin = "_5y-2";